import type * as THREE from "three/webgpu";

export function objectAndAncestorsVisible(obj: THREE.Object3D | null): boolean {
  if (!obj) return false;
  let node: THREE.Object3D | null = obj;
  while (node) {
    if (!node.visible) return false;
    node = node.parent;
  }
  return true;
}
